// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { CycleTimeAnalyticsSection } from '@/report/components/cycle-time-analytics-section';
import { INBOUND_SHIPMENT_CYCLE_TIME_SEGMENTS } from '@/shipment/components/shipment-cycle-time-segments';
import { useInboundShipmentCycleTimeReport } from '@/shipment/hooks/use-inbound-shipment-cycle-time-report';
import type { DateRange } from '@mui/x-date-pickers-pro';
import type { DateTime, IANAZone, Interval } from 'luxon';

const INBOUND_SHIPMENT_CYCLE_TIME_ACCORDION_EXPANDED_STORAGE_KEY =
  'inbound-shipment-cycle-time-accordion-expanded';

interface InboundShipmentAnalyticsSectionProps {
  interval: Interval;
  timezone: IANAZone;
  isDateRangeInvalid: boolean;
  onDateRangeChange: (dateRange: DateRange<DateTime>) => void;
}

function useInboundShipmentCycleTimeReportQuery(filter: {
  interval: Interval;
}) {
  return useInboundShipmentCycleTimeReport({ filter });
}

export function InboundShipmentAnalyticsSection(
  props: InboundShipmentAnalyticsSectionProps
) {
  return (
    <CycleTimeAnalyticsSection
      interval={props.interval}
      timezone={props.timezone}
      isDateRangeInvalid={props.isDateRangeInvalid}
      onDateRangeChange={props.onDateRangeChange}
      segments={INBOUND_SHIPMENT_CYCLE_TIME_SEGMENTS}
      singularNoun="shipment"
      domIdPrefix="inbound-shipment-cycle-time"
      expandedStorageKey={
        INBOUND_SHIPMENT_CYCLE_TIME_ACCORDION_EXPANDED_STORAGE_KEY
      }
      errorBoundaryMessage="Failed to load inbound shipment cycle time report"
      summarySkeletonWidthPx={260}
      useReportQuery={useInboundShipmentCycleTimeReportQuery}
      getTotalCount={(report) => report.totalShipments}
    />
  );
}
